export type ItemId = 'worm' | 'rod' | 'trout' | 'chub' | 'pike' | 'eel' | 'coins' | 'backpack' | 'charm';

export type Item = {
  id: ItemId;
  name: string;
  // Carry weight. The catch weighs the most; bait (worms) carries a little;
  // tools, currency, and carry-vessels (backpack) are weightless.
  weight: number;
  sellable: boolean;
  // Sell value in coins. Only meaningful for sellable items.
  price?: number;
  // Hard cap on how many you can hold, independent of weight. Used for bait
  // (worms): you carry a handful, not a bucketful. Unset = limited only by weight.
  maxStack?: number;
  // Carry-vessel bonus: owning this item raises carry capacity by this much.
  capacityBonus?: number;
  // Meta items (currency, carry-vessels) that have their own HUD and should not
  // appear in the carried-goods inventory list.
  hideInInventory?: boolean;
  // Flavour text shown when the player clicks the item in the inventory.
  // Voice: see the meander-item-writing skill.
  description: string;
};

export const items: Record<ItemId, Item> = {
  worm: {
    id: 'worm',
    name: 'Handful of worms',
    weight: 0.1,
    maxStack: 1,
    sellable: false,
    description: 'A handful of fat worms, dug from the wet earth under the oak. Enough bait for a day by the water.',
  },
  rod: {
    id: 'rod',
    name: 'Fishing rod',
    weight: 0,
    sellable: false,
    description: 'An old rod of hazel and waxed line. It has seen many winters by the water.',
  },
  trout: {
    id: 'trout',
    name: 'Trout',
    weight: 2,
    sellable: true,
    price: 3,
    description: 'A silver trout from the fast water. Firm flesh, and welcome on a fast day.',
  },
  chub: {
    id: 'chub',
    name: 'Chub',
    weight: 2,
    sellable: true,
    price: 2,
    description: 'A fat chub from the slow water. Full of bones, but it fills a pot.',
  },
  pike: {
    id: 'pike',
    name: 'Pike',
    weight: 4,
    sellable: true,
    price: 8,
    description: 'A long pike, all teeth and muscle. The lords pay well for one this size.',
  },
  eel: {
    id: 'eel',
    name: 'Eel',
    weight: 2,
    sellable: true,
    price: 5,
    description: 'A dark eel, taken toward evening. Hard to hold, fine to eat.',
  },
  coins: {
    id: 'coins',
    name: 'Coins',
    weight: 0,
    sellable: false,
    hideInInventory: true,
    description: 'Deniers, the small coin of these parts. Twelve make a sou, and twenty sous a livre.',
  },
  backpack: {
    id: 'backpack',
    name: 'Backpack',
    weight: 0,
    sellable: false,
    capacityBonus: 20,
    hideInInventory: true,
    description: 'A stout pack of good leather. What will not fit in your hands rides on your back.',
  },
  charm: {
    id: 'charm',
    name: 'Protective charm',
    weight: 0,
    sellable: false,
    description: "A small charm, blessed by the priest at the chapel. He swears it keeps the road's dangers from you.",
  },
};
